import request from './request';
export function startPk(data) {
  return request.post('/api/live_pk/startPk', data);
}
export function acceptPk(pkId) {
  return request.post('/api/live_pk/acceptPk', { pk_id: pkId });
}
export function rejectPk(pkId) {
  return request.post('/api/live_pk/rejectPk', { pk_id: pkId });
}
export function getPkInfo(params) {
  return request.get('/api/live_pk/pkInfo', { params });
}
export function pkContribute(data) {
  return request.post('/api/live_pk/pkContribute', data);
}
export function endPk(pkId) {
  return request.post('/api/live_pk/endPk', { pk_id: pkId });
}
export function startMic(data) {
  return request.post('/api/live_pk/startMic', data);
}
export function acceptMic(micId) {
  return request.post('/api/live_pk/acceptMic', { mic_id: micId });
}
export function endMic(micId) {
  return request.post('/api/live_pk/endMic', { mic_id: micId });
}
export function getMicList(roomId) {
  return request.get('/api/live_pk/micList', { params: { room_id: roomId } });
}
